import { create } from 'zustand';
import { LOCAL_STORAGE_KEYS } from 'constant';
import { IFormResultsStore } from '../types/store.types';

export const useFormResultsStore = create<IFormResultsStore>((set) => ({
  filterQueryParams: {
    page: 1,
    per_page: parseInt(
      localStorage.getItem(LOCAL_STORAGE_KEYS.PER_PAGE) ?? '10',
      10,
    ),
    q: '',
    form_result: true,
  },
  totalFiltersToBeCleared: 0,
  filtersData: { dateRange: 'to_date' },

  setFilterQueryParams: (filterQueryParams) => set({ filterQueryParams }),
  setTotalFiltersToBeCleared: (totalFilters) =>
    set({ totalFiltersToBeCleared: totalFilters }),
  updateFilters: (key: string, value: unknown) =>
    set((state) => ({
      filtersData: {
        ...(state.filtersData as Record<string, unknown>),
        [key]: value,
      },
    })),
  clearFilters: () =>
    set(() => ({
      filtersData: {
        dateRange: 'to_date',
      },
    })),
}));
